import styled, { css } from 'styled-components';

interface Props {
  iconUrl: string | null;
  alt: string;
  size: number;
  variant?: 'filled' | 'plain';
  // Internal padding ensures legibility when ChannelIcon paints its own tinted
  // background. Set false when the parent already supplies contrast and the
  // brand glyph should fill the slot (e.g. toolbar IconChip).
  padInside?: boolean;
}

const ChannelIcon = ({
  iconUrl,
  alt,
  size,
  variant = 'filled',
  padInside = true,
}: Props) => {
  return (
    <Cell $size={size} $variant={variant} $padInside={padInside}>
      {iconUrl ? <img src={iconUrl} alt={alt} /> : <Fallback aria-hidden />}
    </Cell>
  );
};

export default ChannelIcon;

const Cell = styled.div<{
  $size: number;
  $variant: 'filled' | 'plain';
  $padInside: boolean;
}>`
  width: ${p => p.$size}px;
  height: ${p => p.$size}px;
  flex: 0 0 auto;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  ${p =>
    p.$variant === 'filled' &&
    css`
      background: var(--surface-elevated);
    `}

  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: ${p =>
      p.$padInside ? `${Math.max(2, Math.round(p.$size / 8))}px` : '0'};
  }
`;

const Fallback = styled.div`
  width: 50%;
  height: 50%;
  border-radius: 50%;
  background: var(--text-secondary);
  opacity: 0.4;
`;
